import { initializeApp, type FirebaseApp, getApps, getApp } from 'firebase/app'
import { getAuth, GithubAuthProvider, GoogleAuthProvider, type Auth } from 'firebase/auth'

// app.nz (appainz) Firebase project. Identity for email/password, Google and
// GitHub sign-in. The Go server verifies the resulting ID token and mints the
// existing app.nz session cookie (see /api/firebase-session).
const firebaseConfig = {
  apiKey: 'AIzaSyBJjTjLFyVUb5Izx5fJl5wlYx3JrN-N07E',
  authDomain: 'appainz-2.firebaseapp.com',
  projectId: 'appainz-2',
  storageBucket: 'appainz-2.firebasestorage.app',
  messagingSenderId: '1065725049829',
  appId: '1:1065725049829:web:8c40cf7665d46777e88d0c',
}

let app: FirebaseApp | undefined
let auth: Auth | undefined

// Guard init to the browser: during SSR/prerender there is no window/IndexedDB,
// and the AuthProvider treats a missing `auth` as "not signed in".
if (typeof window !== 'undefined') {
  try {
    app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)
    auth = getAuth(app)
  } catch (e) {
    console.warn('Firebase init failed:', e)
  }
}

export { app, auth }

export const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({ prompt: 'select_account' })

export const githubProvider = new GithubAuthProvider()
githubProvider.addScope('read:user')
githubProvider.addScope('user:email')

// Connecting GitHub for cloud agents is distinct from signing in. Agents need
// repository access to clone private repos, push branches, and open PRs.
export const githubRepositoryProvider = new GithubAuthProvider()
githubRepositoryProvider.addScope('read:user')
githubRepositoryProvider.addScope('user:email')
githubRepositoryProvider.addScope('repo')
